import { useMemo } from 'react'
import { currentLegacyProfile } from '@/features/book-management/accessLevel'
import { useStaffMe } from '@/api/hooks/shared/useStaffMe'
import { filterNavByGrants, hasAnyGrant, isStaffCaller } from './staffAccess'
import { buildNav, filterNavForRole, type NavGroup } from './nav'
import { useSession } from './queries'

/**
 * The rail for the signed-in operator — book dropdowns by access level, then
 * Logs pages filtered by console role (TM / Master), then Access Level grants.
 */
export function useConsoleNav(): NavGroup[] {
  const { data: session } = useSession()
  const staffMeQ = useStaffMe()
  return useMemo(() => {
    // While /v1/me loads, do not flash the full owner rail (staff would briefly
    // see every page). Owners briefly see a tight rail until me resolves.
    const staffMe =
      staffMeQ.data ??
      (staffMeQ.isPending ? { staffUserId: '__loading__', grants: [] as string[] } : undefined)
    const keepHierarchySearch =
      isStaffCaller(staffMe) && hasAnyGrant(staffMe?.grants, ['hierarchy-search.view'])
    const byRole = filterNavForRole(
      buildNav(currentLegacyProfile(session)),
      session?.account.role,
      { keepHierarchySearch },
    )
    return filterNavByGrants(byRole, staffMe)
  }, [session, staffMeQ.data, staffMeQ.isPending])
}
